
<h1 mat-dialog-title>{{dialogData.type}} löschen</h1>
<div mat-dialog-content>
    <p>Bist du dir sicher, dass du {{dialogData.type}} löschen möchtest?</p>
    <p>Dieser Vorgang kann nicht rückgängig gemacht werden.</p>
</div>
<div mat-dialog-actions class="actions">
    <button mat-button [mat-dialog-close]="false">Abbrechen</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">Löschen</button>
</div>